import { Countdown, Icon, Typography } from '@/primer/components';

export interface AccountLockoutProps {
  expiresAt: number;
  onExpire: () => void;
}

export function AccountLockout({ expiresAt, onExpire }: AccountLockoutProps) {
  return (
    <div className="flex flex-col items-center gap-5 text-center">
      <div className="flex size-10 items-center justify-center rounded-full bg-interactive-quiet">
        <Icon name="lock" size="large" color="interactive" aria-hidden="true" />
      </div>
      <div className="flex flex-col gap-3">
        <Typography variant="header" size="h1" as="h1" align="center">
          Account temporarily locked
        </Typography>
        <Typography variant="body" size="medium" align="center">
          Too many incorrect attempts to log in.
          <br />
          You can try again in
        </Typography>
      </div>
      <div className="mt-3">
        <Countdown
          key={expiresAt}
          expiresAt={expiresAt}
          format="minutes-seconds"
          size="huge"
          aria-label="Account unlocks in"
          onExpire={onExpire}
        />
      </div>
    </div>
  );
}
